module.exports = __webpack_public_path__ + "static/media/Colette Straight Single Headboard - 90 cm_Burnt Orange.a5dda261.png";